import React, { forwardRef } from 'react';

interface FabricCanvasProps {
  className?: string;
  width?: number;
  height?: number;
}

export const FabricCanvas = forwardRef<HTMLCanvasElement, FabricCanvasProps>(
  ({ className, width = 1400, height = 800 }, ref) => {
    return (
      <canvas
        ref={ref}
        className={className}
        width={width}
        height={height}
      />
    );
  }
);

FabricCanvas.displayName = 'FabricCanvas';
